export default __webpack_public_path__ + "static/media/amaze-12.85c45ed0.jpg";